export default {
    indexTermTags:     { method: 'get',    url: 'term_tags' },
    createTermTag:     { method: 'post',   url: 'term_tags'},
    updateTermTag:     { method: 'put',    url: 'term_tags/{id}'},
    destroyTermTag:    { method: 'delete', url: 'term_tags/{id}'},
}